// Note this is not the same as the "Obsolete" product lifecycle synced from NetSuite, which does not appear to be maintained
export const obsoleteHeatPumpUnitCodes: ReadonlyArray<string> = [
  'HPF2040/12(10)-A',
  'HPF2040/12(10)B-A',
  'HPF2040/16(13)-A',
  'HPF2040/16(13)B-A',
  'HPAP(AH)/12-A',
  'HPAP(AH)/12(B)-A',
  'HPAP(AH)/16-A',
  'HPAP(AH)/16(B)-A',
];

export const getHeatPumpUnitSelectOptionText = (heatPumpUnitCode: string): string =>
  obsoleteHeatPumpUnitCodes.includes(heatPumpUnitCode) ? `[Obsolete] ${heatPumpUnitCode}` : heatPumpUnitCode;
